import React from "react";
import { Radio } from "antd";
const RadioGroup = Radio.Group;

function MultipleChoice({ id, title, description, choices, value, onChange }) {
  const renderChoices = choices.map(choice => (
    <div id="multiplechoiceClass">
      <form>{choice.title}</form>
      <Radio
        style={{
          padding: "7px "
        }}
        value={choice.value}
      >
        {choice.description}
      </Radio>
    </div>
  ));
  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "10px 0px 30px",
        borderRadius: "5px"
      }}
    >
      <h3
        style={{
          padding: "20px",
          color: "#1ABC9C",
          fontSize: "20px",
          textTransform: "uppercase"
        }}
      >
        {title}
      </h3>
      <RadioGroup key={id} name={id} onChange={onChange}>
        {renderChoices}
      </RadioGroup>
    </div>
  );
}

export default MultipleChoice;



// WEBPACK FOOTER //
// ./src/components/MultipleChoice/index.js